import { getCookies, setCookies } from '@/utils/token'
import { getStore } from '@/utils/dva'

export default {
    setItem(name, value) {
        if (!name) return
        if (typeof value !== 'string') {
            value = JSON.stringify(value)
        }
        window.localStorage.setItem(name, value)
    },
    getItem(name) {
        if (!name) return
        let value = window.localStorage.getItem(name)
        try {
            return typeof value === 'string' ? JSON.parse(value) : value
        } catch (err) {
            console.error('catchError', err)
            // JSON.parse 处理不了非规范的 json，将 value 返回
            return value
        }
    },
    removeItem(name) {
        if (!name) return
        window.localStorage.removeItem(name)
    },
}

export const checkCookiesStorage = ({ val, key }) => {
    const { currentUser } = getStore().getState().user
    const realVal = `${val}-${currentUser.uid}`
    const res = getCookies(key) || ''
    if (res.indexOf(realVal) > -1) {
        return true
    }
    return false
}

const defaultMaxLength = 10

export const setCookiesStorage = ({ val, key, maxLength }) => {
    const { currentUser } = getStore().getState().user
    const realVal = `${val}-${currentUser.uid}`
    const res = getCookies(key) || []
    let nextVal = res
    if (nextVal.indexOf(realVal) > -1) {
        return true
    }
    if (nextVal.length >= (maxLength || defaultMaxLength)) {
        nextVal.shift()
    }
    nextVal = [...nextVal, realVal]
    setCookies(key, nextVal)
    return true
}
